module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAAAFCAYAAAAaPoE/AAAAKUlEQVQ4jWNkYGD4zzDCAcv//yM+DBiYBtoBgwGMBgLDaCAwMDAwMAAAYXIECLFCZ0oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/text-line-1.png
// module id = 2YHK
// module chunks = 1